import "./Home.css";
import HeroPanel from "./HeroPanel/HeroPanel";
import ReferenceBubbles from "./ReferenceBubbles/ReferenceBubbles";
import WhyCards from "./WhyCards/WhyCards";
import ServicesTeaser from "./ServicesTeaser/ServicesTeaser";
import ProcessFlow from "./ProcessFlow/ProcessFlow";
import SEO from "../../components/SEO/SEO";

function Home() {
  return (
    <div className="home-container">

      <>
      <SEO
        title="Fit to Clean – Professionelle Reinigung & Gebäudeservice"
        description="Fit to Clean ist Ihr zuverlässiger Partner für professionelle Reinigungsleistungen."
        canonical="https://www.fit-to-clean.de/"
      />

      <div className="hero fade-in-up">
        <HeroPanel
          eyebrow="Wir verschaffen Ihnen einen glänzenden Auftritt"
          title="Gebäudereinigung & Büroreinigung in und um München"
          text="Wir halten Büros und gewerbliche Objekte zuverlässig sauber. Unser Team ist im gesamten MVV-Gebiet für Sie im Einsatz – gründlich, flexibel und diskret."
          ctaLabel="Kostenlose Anfrage"
          ctaHref="/contact"
        />
      </div>

      <div className="services fade-in-up">
        <ServicesTeaser
          title="Unsere Leistungen im Überblick"
          text="Ein gepflegtes Objekt trägt zu Wohlbefinden, Produktivität und einem professionellen Erscheinungsbild bei. Wir sorgen dafür, dass alles sauber bleibt."

          eyebrow1="Regelmäßige Reinigung"
          subTitle1="Büro- & Praxisreinigung"
          subText1="Wir reinigen Arbeitsplätze, Empfangsbereiche und Sanitärräume zuverlässig nach festen Plänen."

          eyebrow2="Gemeinschaftsflächen"
          subTitle2="Treppenhaus- & Sanitärpflege"
          subText2="Saubere Zugänge und gepflegte Sanitärbereiche sorgen täglich für einen guten Eindruck."

          eyebrow3="Hygiene & Sicherheit"
          subTitle3="Desinfektionsreinigung"
          subText3="In sensiblen Bereichen setzen wir schonende Hygienekonzepte für sichere Räume um."

          eyebrow4="Spezialservices*"
          subTitle4="Teppich-, Außen- & Sonderreinigung"
          subText4="Von Teppichgrundreinigung bis Graffiti-Entfernung – in Zusammenarbeit mit Partnerbetrieben."

          ctaButtonText="Mehr zu den Leistungen"
        />
      </div>

      <div className="references fade-in-up">
        <ReferenceBubbles
          title="Kunden aus vielen Branchen"
          subText="Vom Einzelbüro bis zum gesamten Objekt – wir sind in unterschiedlichen Branchen im Großraum München im Einsatz."
          references={[
            "Apotheken",
            "Arzt-Praxen",
            "Beratungsunternehmen",
            "Coaching für Führungskräfte",
            "Beratungsinstitute im Sozialbereich",
            "Event-Agenturen",
            "Einrichtungshäuser",
            "Immobilien-Verwaltungen",
            "Investment-Gruppen",
            "Kindergärten & Kitas",
            "Marketing-Agenturen",
            "Media- & Werbeagenturen",
            "Mode- und Bekleidungsgeschäfte",
            "Pharma-Unternehmen (Büroflächen)",
            "Physiotherapie-Studios",
            "Rechtsanwaltskanzleien",
            "Sport- & Fitnessstudios",
            "Unternehmensberatungen",
            "Sicherheitsberatungen",
            "Zahnarzt-Praxen",
          ]}
        />
      </div>
        
      <div className="process-flow fade-in-up">
          <ProcessFlow
            title="So starten Sie mit uns"
            text="Der Weg zu dauerhaft sauberen Räumen ist leichter, als Sie denken."
            ctaLabel="Jetzt Kontakt aufnehmen"
            step1Title="Anfrage"
            step1Text="Sie senden uns die wichtigsten Eckdaten zu Ihrem Objekt und Ihren Anforderungen."
            step2Title="Kostenlose Beratung & Angebot"
            step2Text="Wir besichtigen Ihr Objekt bei Bedarf und erstellen ein klares, faires Angebot."
            step3Title="Glänzender Auftritt"
            step3Text="Unser Team übernimmt zuverlässig die regelmäßige Reinigung – mit festen Abläufen und Qualitätskontrollen."
          />
      </div>

      <div className="why fade-in-up">
        <WhyCards
          title={
            <>
              Warum <span className="accent-text">Fit</span>
              <span className="accent-text2">2</span>
              <span className="accent-text">Clean</span>?
            </>
          }
          subTitle1="Planbare Sauberkeit"
          subText1="Wir arbeiten mit festen Ansprechpartnern und klaren Reinigungsplänen."

          subTitle2="Flexibel für Ihren Betrieb"
          subText2="Reinigung außerhalb Ihrer Arbeitszeiten – wann immer es am besten passt."

          subTitle3="Persönlicher Service"
          subText3="Sie erhalten eine Lösung, die exakt zu Ihrem Objekt und Ihren Bedürfnissen passt."

          subTitle4="Gründlich & modern"
          subText4="Unser Team nutzt moderne Methoden und schonende Reinigungsmittel."

          ctaText="Angebot anfordern"
        />
      </div>
    </>
    </div>
  );
}

export default Home;
